import type { PageTelemetryContextValue } from '../context';

import { usePageTelemetryContext } from './usePageTelemetryContext';

export const usePageTelemetryContextSetRouteCallback = (): PageTelemetryContextValue['setRoute'] | undefined =>
  usePageTelemetryContext()?.setRoute;
